<!-- 全部商品 -->
<template>
  <div>
    <div class="head-title">
      自提点列表
      <span
        style="color: #f96460; cursor: pointer; font-size: 14px"
        @click="onSubmit1 = true"
        >配置教程</span
      >
    </div>
    <nav class="navbar">
      <div class="nav-l">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          :loading="updateLoading"
          @click="getRenew"
          >更新列表</el-button
        >
      </div>
      <div class="nav-r">
        <el-input
          clearable
          style="width: 35.0rem; margin: 0 2.0rem 0 2.0rem"
          placeholder="请输入自提点名称"
          prefix-icon="el-icon-search"
          v-model="q"
          @change="getList()"
        >
        <el-button slot="append" type="primary" @click="getList()"
          >查询</el-button
        >
        </el-input>
        
      </div>
    </nav>
    <div class="main">
      <div class="container">
        <el-table
          :data="tableData"
          border
          header-align="center"
          align="center"
        >
          <el-table-column
            prop="siteName"
            label="自提点名称"
            width="180"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="siteTel" label="自提点联系电话" width="140">
          </el-table-column>
          <el-table-column prop="businessDayStr" label="营业日" width="140">
          </el-table-column>
          <el-table-column
            prop="businessTimeStr"
            label="营业时间"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="provinceName" label="所在省" width="160">
          </el-table-column>
          <el-table-column prop="cityName" label="所在市" width="160">
          </el-table-column>
          <el-table-column prop="countyName" label="所在区" width="160">
          </el-table-column>
          <el-table-column prop="areaName" label="所在乡镇" width="160">
            <template slot-scope="scope">
              <div class="sales-status">
                <span class="s-tag">
                  {{ scope.row.areaName == null ? "暂无" : scope.row.areaName }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="isUse" label="是否启用">
            <template slot-scope="scope">
              <div class="sales-status">
                <span class="s-tag">
                  {{ scope.row.isPutAway == 0 ? "未启用" : "启用" }}
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            :auto-scroll="false"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
    <el-dialog title="配置教程" center :visible.sync="onSubmit1" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../../assets/order.jpg" alt />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit1 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit1 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

  <script>
import { auth } from "./mixins/wm.js";
export default {
  name: "selfList",
  components: {},
  mixins: [auth],
  data() {
    return {
      q: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      updateLoading: false,
      onSubmit1: false,
    };
  },

  computed: {},
  beforeRouteLeave(to,from,next){
    let arr = ['storelist','selfList','goodsList','orderlist','customerlist']
    if(!arr.includes(to.name)){
      this.$store.state.enterWeimeng=false
    }
    next()
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新历史朋友圈数据
      const { data: res } = await this.axios({
        url: "weimob/merchant/TakeTheir/updateList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          // account_id: 579,
        }),
      });
      this.updateLoading = false;
      this.tableData = [];
      this.getList();
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "weimob/merchant/TakeTheir/getList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          // account_id: 579,
          page: this.listQuery.page,
          listRows: this.listQuery.limit,
          siteName: this.q,
        }),
      });
      if (res.code == 1) {
        this.tableData = res.data.data;
        this.total = res.count;
      }
    },
  },
};
</script>
  <style lang="scss" scoped>
.main {
  margin-top: 3.0rem;
}

.scope-title {
  display: flex;
  &-img {
    width: 36px;
  }
  &-text {
    flex: 1;
    margin-left: 8px;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    cursor: pointer;
  }
}
</style>
